<template >
  <div class="z-40 overflow-hidden">
    <div class="mt-2 mb-5">
    </div>
    <div class="grid grid-cols-4 md:grid-cols-5 xl:grid-cols-6 gap-3 z-20">
      <transition name="slide-up">
        <div v-if="isUrlInputOpen" class="col-span-full grid grid-cols-3 gap-3">
          <div class="col-span-2">
            <label class="text-xs font-bold text-indigo-600" for="icon-url">Icon from URL</label>
            <input class="text-indigo-600  focus:outline-none  bg-white font-normal w-full h-10 flex items-center border px-3 text-sm rounded shadow transition-color" id="icon-url" placeholder="Url of the image" type="text" v-model="iconFromUrl" autocomplete="off" />
          </div>
          <div class="col-span-1 flex">
            <h4 @click="setIconFromUrl" class="btn-default table mt-auto" :class="[{'opacity-25 cursor-default active:scale-100' : !iconFromUrl}]">Apply Url</h4>
          </div>
        </div>
      </transition>

      <div class="col-span-2 md:col-span-3 flex">
        <h4 @click="isUrlInputOpen = !isUrlInputOpen" class="btn-default my-auto" :class="popWarnClass">Select from URL</h4>
      </div>
      <div class="col-span-2 xl:col-span-3 grid grid-cols-3">
        <div class="mx-auto w-16 h-16 rounded-full border-2 overflow-hidden transform hover:scale-105 active:scale-100 col-span-1" :class="[{ 'border-indigo-700' : costumIcon.isValidated },'border-red-400']" >
        <img @click="setNewIcon(costumIcon.src)" class="image-full-size" :src="costumIcon.src" alt="User Icon" @error="errorCostumIcon()" />
        </div>
        <div class="col-span-2">
        <transition name="slide-up">
        <div v-if="costumIcon.errorMessage" class="flex justify-between my-1 space-x-2" >
          <h6  class="text-pink-600 text-xs font-bold">{{costumIcon.errorMessage}}</h6>
          <h6 @click="costumIcon.errorMessage = ''" class="text-pink-600 text-xs font-bold cursor-pointer">x</h6>
        </div>
        </transition>
        </div>
      </div>  
      <div v-if="defaultIcon" class="mx-auto w-20 h-20 rounded-full border-2  pop-click overflow-hidden" :class="[{ 'border-indigo-700' : defaultIcon === currentSelectedIcon },'border-green-500']"   >
        <img  @click="setNewIcon(defaultIcon)" class="min-w-full min-h-full relative top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 cursor-pointer transition-all select-none" :src="currentSelectedIcon" alt="User Icon">
      </div>
      <div v-for="(icon, index) in icons" :key="index" class="mx-auto w-20 h-20 rounded-full border-2  pop-click overflow-hidden" :class="[{ 'border-indigo-700' : iconsUrl + icon.seed === currentSelectedIcon },'border-green-500']"  >
        <img @click="setNewIcon(iconsUrl + icon.seed)" class="min-w-full min-h-full relative top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 cursor-pointer transition-all select-none" :src="iconsUrl + icon.seed" alt="User Icon">
      </div>
    </div>
    <google-loader v-if="isAddingIcon" widthClass="w-20 py-4"></google-loader>
  </div>

</template>

<script>
import GoogleLoader from '@/components/GoogleLoader.vue';

export default {
  name : '#ction',
  data() {
    return {
      isAddingIcon : false,
      defaultIcon : this.currentSelectedIcon,
      popWarnClass : "",
      iconSize : '&w=300&h=300',
      isUrlInputOpen : false,
      blankIcon : "/profile-icons/blank.png",
      iconFromUrl : "",
      costumIcon : {
        "src" : "",
        "errorMessage" : "",
        "isValidated" : false
      },
      icons : {
        
      },
      iconsRootFilePath : 'https://avatars.dicebear.com/api/'
    }
  },
  components : {
    'google-loader' : GoogleLoader,
  },
  emits : ['setNewIcon'],
  props : {
    currentSelectedIcon : String,
    isForChatRoom : Boolean,
    iconBackground : {
      type: String,
      default: 'baf7f4'
    },
  },
  mounted(){
    this.generateSeedIcon()
  },
  computed : {
    iconsUrl (){
      if(!this.isForChatRoom)return this.iconsRootFilePath + 'micah/';
      return this.iconsRootFilePath + 'gridy/';
    }
  },
  methods : {
    generateSeedIcon(limit = 35){
      if(this.isAddingIcon)return;
      this.isAddingIcon = true;
      const existingSeedsCount = Object.keys(this.icons).length;
      for(var i = existingSeedsCount; i < (existingSeedsCount + limit); i ++){
        this.icons[i] = {
          seed : i + '.svg?b=%23' + this.iconBackground + this.iconSize,
        }
      }
      this.isAddingIcon = false;

    },
    popWarning(){
      this.popWarnClass = "pop-warn";
      setTimeout(()=>{
        this.popWarnClass = "";
      }, 600)
    },
    showIconSelection(toShow = true,defaultIcon){
      if(defaultIcon)this.defaultIcon = defaultIcon;
      this.isVisible = toShow;
    },
    setNewIcon(newIcon){
      this.$emit('setNewIcon',newIcon);
      this.showIconSelection(false);
      this.costumIcon.errorMessage = "";
    },
    errorCostumIcon(errorMessage){
      this.costumIcon.isValidated = false;
      this.costumIcon.src = this.blankIcon;
      
      //invalid image is from url
      if(this.iconFromUrl.length > 0){
        this.costumIcon.errorMessage = "Image URL selected was Invalid";
        this.iconFromUrl = "";
        return;
      }

      //costum error message
      this.costumIcon.errorMessage = errorMessage;
    },
    setIconFromUrl(){
      if(!this.iconFromUrl)return;
      this.costumIcon.src = this.iconFromUrl;
      this.isUrlInputOpen = false;
      this.costumIcon.errorMessage = "";
      this.costumIcon.isValidated = true;
    },
    
  }
}
</script>

<style scoped>
.pop-warn{
  animation-name: example;
  animation-duration: 600ms;
}
@keyframes example {
  from {transform: scale(1);}
  to {transform: scale(1.05);}
}
</style>
